import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import adapter from '../adapter';
export default function divFactory() {
  var _Div;
  var _adapter$getRuntime = adapter.getRuntime(),
    PureComponent = _adapter$getRuntime.PureComponent,
    createElement = _adapter$getRuntime.createElement;
  return _Div = /*#__PURE__*/function (_PureComponent) {
    _inheritsLoose(Div, _PureComponent);
    function Div() {
      return _PureComponent.apply(this, arguments) || this;
    }
    var _proto = Div.prototype;
    _proto.render = function render() {
      return createElement('div', this.props);
    };
    return Div;
  }(PureComponent), _Div.displayName = 'Div', _Div.version = '0.0.0', _Div;
}